export const HTTP_METHOD = {
  get: 'GET',
  post: 'POST'
};

export const TRANS = {
  auth_code: 'auth_code',
  client_credentials: 'client_credentials',
  auth_metadata: 'auth_metadata'
}

const ALPHA_NUMERIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const PROTECTION_LENGTH = 30;

const CHALLENGE_TEXT_ENCODING = 'US-ASCII';
const CHALLENGE_ALGORITHM = 'SHA-256';
const CHALLENGE_METHOD = 'S256';

export const AUTH_HEADER = 'Authorization';
export const AUTH_BASIC_PREFIX = 'Basic';
export const CT_JSON_HEADER =  {"Content-type": "application/json"};
export const CT_FORM_HEADER =  {"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"};

export const AUTH_CODE_RESPONSE_TYPE = 'code';
export const AUTH_CODE_GRANT_TYPE = 'authorization_code';
export const CLIENT_CRED_GRANT_TYPE = 'client_credentials';

export const AUTH_INFO = {
  httpMethod: 'Method',
  httpHeaders: 'Headers',
  httpBody: 'Body',
  // authorizeUri: '',
  // tokenUri: '',
  redirectUri: 'redirect_uri',
  clientId: 'client_id',
  clientSecret: 'client_secret',
  scopes: 'scope',
  state: 'state',
  nonce: 'nonce',
  responseType: 'response_type',
  grantType: 'grant_type',
  code: 'code',
  codeChallenge: 'code_challenge',
  codeChallengeMethod: 'code_challenge_method',
  codeVerifier: 'code_verifier'
};

// Utils

export function objectToString(obj) {
  let result = [];
  for (let key in obj) {
    result.push(key + ": " + obj[key]);
  }
  result = result.join('\n');
  return result;
}

export function buildFormBody(params) {
  let formBody = [];
  for (let key in params) {
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(params[key]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  return formBody;
}

// PKCE

function generateCodeVerifier() {
  const randomByteArray = new Uint8Array(32);
  window.crypto.getRandomValues(randomByteArray);

  let codeVerifier = base64urlEncode(randomByteArray);
  return codeVerifier;
}

function base64urlEncode(sourceValue) {
  const stringValue = String.fromCharCode.apply(null, sourceValue);
  // TODO: btoa is deprecated
  const base64Encoded = btoa(stringValue);
  const base64urlEncoded = base64Encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  return base64urlEncoded;
}

export async function generatePKCE() {
  let codeVerifier = generateCodeVerifier();
  
  const textEncoder = new TextEncoder(CHALLENGE_TEXT_ENCODING);
  const encodedValue = textEncoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest(CHALLENGE_ALGORITHM, encodedValue);

  let codeChallenge = base64urlEncode(Array.from(new Uint8Array(digest)));  

  return {
    codeChallenge: codeChallenge,
    codeChallengeMethod: CHALLENGE_METHOD,
    codeVerifier: codeVerifier
  };
}

// STATE and NONCE

function generateProtection() {
	let protection = '';
  const charLength = ALPHA_NUMERIC_CHARS.length;
  for (let i = 0; i < PROTECTION_LENGTH; i++) {
    protection += ALPHA_NUMERIC_CHARS.charAt(Math.floor(Math.random() * charLength));
  }
  return protection;
}

export function generateState() {
  const state = generateProtection();
  return state;
}

export function generateNonce() {
  const nonce = generateProtection();
  return nonce;
}

// Search Data in URL path

export function getCodeFromSearchData(searchData) {
  if (!searchData) {
    return '';
  }
  searchData = (searchData.length > 1 && searchData.startsWith('?')) ? searchData.substring(1) : searchData;

  const params = searchData.split('&');
  let code = params
    .filter(param => param.startsWith('code='))
    .map(param => param.substring('code='.length));

  return code.length && code[0];
}

export function getSearchDataText(searchData) {
  if (!searchData) {
    return '';
  }
  searchData = (searchData.length > 1 && searchData.startsWith('?')) ? searchData.substring(1) : searchData;
      
  let errMsg = searchData.split('&');
  errMsg = errMsg.join('\n');
  return decodeURIComponent(errMsg);  
}

// Client Credentials
export function getBase64Credentials(clientId, clientSecret) {
	return btoa(clientId + ":" + clientSecret);
}

export function cleanup() {
  // sessionStorage.removeItem('transType');
  sessionStorage.removeItem('tokenUri');
  sessionStorage.removeItem('clientId');
  sessionStorage.removeItem('clientSecret');
  sessionStorage.removeItem('redirectUri');
  sessionStorage.removeItem('codeVerifier');
}

// Algorithm

export function getAlgorithm(alg) {
  if (alg.length < 2) {
    return alg;
  }
  let prefix = '';
  switch(alg.substring(0,2)) {
    case 'RS': 
      prefix = 'RSASHA';
      break;
    case 'HS': 
      prefix = 'HMACSHA';
      break;
    case 'ES': 
      prefix = 'ECDSASHA';
      break;
    case 'PS': 
      prefix = 'RSAPSSSHA';
      break;
  }
  return prefix + alg.substring(2);
}
